import style from "./styles/MainVideo.module.css";

import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReactPlayer from "react-player/lazy";

import { getChannel } from "../../redux/actions";
import { addVideo } from "../../redux/actions";

import CardVideoChannel from "../CardVideoChannel/CardVideoChannel";
import CardVideo from "../CardVideo/CardVideo";
import SearchBar from "../SearchBar/SearchBar";

import { IItemVideo, IState, IDataVideo } from "../../interface/interface";

// Order imports
// Styles
// Native and other dependences
// Actions Redux
// Actions Controllers and constants
// Components
// Interfaces

const MainVideo = () => {
  const dispatch = useDispatch();

  const [view, setView] = useState<string>("videos");
  const [videoUrl, setVideoUrl] = useState<string[]>([
    `https://www.youtube.com/watch?v=6FgF7hKwcao&ab_channel=Black%26White`,
  ]);

  const infoApi = useSelector<IState, IState["infoApi"]>(
    (state) => state.infoApi
  );
  const channelInfoApi = useSelector<IState, IState["channelInfoApi"]>(
    (state) => state.channelInfoApi
  );
  const listVideo = useSelector<IState, IState["listVideos"]>(
    (state) => state.listVideos
  );
  const [video, setVideo] = useState<IDataVideo>({
    videoId: "",
    title: "",
    image: "",
    channel: "",
  });

  let fiveImage =
    "https://www.pngmart.com/files/14/5-Number-PNG-Background-Image.png";

  const getChannelId = (channelId: string, value: string) => {
    if (channelId) {
      dispatch(getChannel(channelId));
    }
    setView(value);
  };

  const goBack = (value: string) => {
    setView(value);
  };

  const addVideoList = (v: any) => {
    let newObjectVideo: IItemVideo = {
      position: listVideo.videos.length,
      videoId: v.videoId,
      title: v.title,
      image: v.image || v.imageM,
      channel: v.channelTitle,
    };
    dispatch(addVideo(newObjectVideo));
  };

  const selectVideo = (v: any) => {
    console.log(v, "el id del vídeo que llega");
    let video: IDataVideo = {
      videoId: v.videoId,
      title: v.title,
      image: v.imageM,
      channel: v.channelTitle,
    };
    setVideo(video);
  };
  //---------------------------------------------------------------------
  // https://www.youtube.com/watch?v=_w4sPyiNdBY&ab_channel=angeloDev
  // Y si uso ReactPlayer?
  //---------------------------------------------------------------------
  // https://www.npmjs.com/package/react-player
  //---------------------------------------------------------------------

  const getUrlVideo = (idVideo: string, titleChannel: string) => {
    const origin = process.env.REACT_APP_API || "http://localhost:3001/";
    if (idVideo && titleChannel) {
      setVideoUrl([
        `https://www.youtube.com/watch?v=${idVideo}?showinfo=0&enablejsapi=1&origin=${origin}`,
      ]);
    }
  };

  const playList = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    let playList: string[] = [];

    if (listVideo.videos.length > 0) {
      playList = listVideo.videos.map((v: any) => {
        return `https://www.youtube.com/watch?v=${v.videoId}?showinfo=0&enablejsapi=1&origin=https://localhost:3000`;
      });
    }
    if (listVideo.videos.length > 0) {
      setVideoUrl(playList);
    }
  };

  return (
    <>
      <div className={style.mainVideo}>
        {videoUrl ? (
          <ReactPlayer
            url={videoUrl}
            controls={true}
            config={{ youtube: { playerVars: { rel: 0, showinfo: 0 } } }}
            style={{ maxWidth: "100%", maxHeight: "100%" }}
          />
        ) : null}
      </div>

      <div className={style.mainSearch}>
        <div className={style.searchBox}>
          <SearchBar />
        </div>
        {/* <div className={style.searchButtonBox}>
          <button onClick={(e) => playList(e)} className={style.playButton}>
            Play lists
          </button>
        </div> */}
      </div>

      <div className={style.mainResults}>
        <ul className={style.mainCardVideo}>
          {infoApi.items && infoApi.items.length > 0 && view === "videos"
            ? infoApi.items.map((i: any) => {
                return (
                  <li key={i.videoId} className={style.cardVideo}>
                    <CardVideo
                      image={i.imageH}
                      title={i.title}
                      description={i.description}
                      channelId={i.channelId}
                      videoId={i.videoId}
                      channelTitle={i.channelTitle}
                      getUrlVideo={() => getUrlVideo(i.videoId, i.channelTitle)}
                      getChannel={() =>
                        getChannelId(i.channelId, "channelVideos")
                      }
                      addVideoList={() => addVideoList(i)}
                      selectVideo={() => selectVideo(i)}
                    />
                  </li>
                );
              })
            : null}
          {infoApi.items && infoApi.items.length > 0 && view === "videos" ? (
            <li key="next" className={style.cardVideo}>
              <div className={style.middleCardImage}>
                <div className={style.boxImage5}>
                  <img
                    src={fiveImage}
                    className={style.imageCardVideo5}
                    alt={"five"}
                  ></img>
                </div>
                <div className={style.cardVideo5Buttons}>
                  {/* <button >Prev</button>
                                    <button >Next</button> */}
                </div>
              </div>
            </li>
          ) : null}

          {channelInfoApi.items &&
          channelInfoApi.items.length > 0 &&
          view === "channelVideos"
            ? channelInfoApi.items.map((i: any) => {
                return (
                  <li key={i.videoId} className={style.cardVideo}>
                    <CardVideoChannel
                      image={i.imageH}
                      title={i.title}
                      description={i.description}
                      channelId={i.channelId}
                      videoId={i.videoId}
                      channelTitle={i.channelTitle}
                      getUrlVideo={() => getUrlVideo(i.videoId, i.channelTitle)}
                      goBack={() => goBack("videos")}
                      addVideoList={() => addVideoList(i)}
                    />
                  </li>
                );
              })
            : null}
          {channelInfoApi.items &&
          channelInfoApi.items.length > 0 &&
          view === "channelVideos" ? (
            <li key="next" className={style.cardVideo}>
              <div className={style.middleCardImage}>
                <div className={style.boxImage5}>
                  <img
                    src={fiveImage}
                    className={style.imageCardVideo5}
                    alt={"five"}
                  ></img>
                </div>
                <div className={style.cardVideo5Buttons}>
                  {/* <button >Prev</button>
                                    <button >Next</button> */}
                </div>
              </div>
            </li>
          ) : null}
        </ul>
      </div>
      <div className={style.mainSelecVideo}>
        <div className={style.descriptionVideoBox}>
          <p className={style.singleLineDescription}>{video?.title}</p>
          {/* <p className={style.videoDescription}><strong>{selected.title}</strong></p> */}
          {/* <p style={{ display: "none" }}>{selected.description}</p>
                    <p style={{ display: "none" }}>Id del canal: {selected.channelId}</p> */}
        </div>
        <div className={style.addVideoButton}>
          <button onClick={() => getUrlVideo(video.videoId, video.channel)}>
            Play
          </button>
          <button onClick={() => addVideoList(video)}>Add</button>
        </div>
      </div>

      <div className={style.playButtonBox}>
        <button onClick={(e) => playList(e)} className={style.playButton}>
          Play lists
        </button>
      </div>
    </>
  );
};

export default MainVideo;
